"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import {
  getBrandSlug,
  type StrapiCollectionResponse,
  type StrapiEntity,
  type StrapiQuery,
  type StrapiQueryValue,
} from "@/lib/strapi";
import type { BrandAttributes } from "@/services/brand";

export type UseBrandOptions = {
  slug?: string;
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  initialData?: StrapiCollectionResponse<BrandAttributes> | null;
};

export function useBrand(options?: UseBrandOptions) {
  const slug = options?.slug ?? getBrandSlug();

  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    filters: {
      ...(typeof options?.query?.filters === "object" && options?.query?.filters !== null
        ? (options.query.filters as Record<string, unknown>)
        : {}),
      slug: { $eq: slug },
    },
    populate:
      options?.populate !== undefined
        ? options.populate
        : (options?.query?.populate ?? {
            profiles: { populate: "*" },
            contact_info: { populate: "*" },
            social_links: { populate: "*" },
          }),
  };

  const state = useFetchApi<StrapiCollectionResponse<BrandAttributes>>("/brands", {
    enabled: options?.enabled,
    query,
    withBrandFilter: false,
    initialData: options?.initialData,
  });

  const brand: StrapiEntity<BrandAttributes> | null = state.data?.data?.[0] ?? null;

  return { ...state, brand };
}
